import { guideSteps } from '@/mocks/homeContent';

const testimonials = [
  {
    name: '瓜友·阿橘',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20avatar%20of%20a%20friendly%20orange%20cat%20with%20warm%20smile%2C%20soft%20flat%20illustration%2C%20simple%20cream%20background&width=200&height=200&seq=avatar-aju&orientation=squarish',
    text: '每天下班第一件事就是刷53吃瓜，追更进度没断过，评论区唠嗑氛围特别好，像一群老友聚在一起。',
  },
  {
    name: '瓜友·追更达人',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20avatar%20of%20an%20energetic%20young%20woman%20wearing%20headphones%2C%20soft%20flat%20illustration%2C%20simple%20cream%20background&width=200&height=200&seq=avatar-zhui&orientation=squarish',
    text: '投稿流程真的很简单，我随手写了个新瓜分享，几分钟就有瓜友来互动，成就感满满。',
  },
  {
    name: '瓜友·冲浪新手',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20avatar%20of%20a%20curious%20young%20man%20holding%20a%20surfboard%2C%20soft%20flat%20illustration%2C%20simple%20cream%20background&width=200&height=200&seq=avatar-chonglang&orientation=squarish',
    text: '栏目分类做得很细，想看综艺还是热剧都一目了然，再也不用在别的平台大海捞针了。',
  },
];

export default function Community() {
  return (
    <section id="guide" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-bold uppercase tracking-widest text-primary-600">How to Play</span>
          <h2 className="mt-1 font-heading text-3xl text-foreground-950 md:text-4xl">四步开始玩瓜</h2>
          <p className="mt-2 text-sm text-foreground-700">从看瓜到发帖，几个简单动作就能加入唠嗑大队。</p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {guideSteps.map((g) => (
            <div key={g.step} className="relative rounded-xl border border-background-200 bg-background-50 p-5">
              <span className="font-heading absolute right-4 top-3 text-5xl text-secondary-200">{g.step}</span>
              <div className="relative flex h-11 w-11 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                <i className={`${g.icon} text-xl`}></i>
              </div>
              <h3 className="relative mt-4 text-base font-bold text-foreground-950">{g.title}</h3>
              <p className="relative mt-2 text-sm leading-relaxed text-foreground-700">{g.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 grid grid-cols-1 items-center gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex flex-col gap-2">
              <span className="text-xs font-bold uppercase tracking-widest text-accent-600">About 53吃瓜</span>
              <h2 className="font-heading text-3xl text-foreground-950 md:text-4xl">一个轻松唠嗑、靠谱追更的瓜友聚集地</h2>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              53吃瓜致力于把每天最值得聊的新鲜话题和瓜友投稿集中到一处。我们相信，有趣的分享不该被淹没在杂乱的信息流里，
              所以用清晰的栏目分类和实时热榜，让每个人都能轻松找到想追的瓜、聊得上话的人。
            </p>
            <ul className="mt-5 flex flex-col gap-3 text-sm text-foreground-800">
              <li className="flex items-start gap-2"><i className="ri-checkbox-circle-fill mt-0.5 text-accent-500"></i>内容真实优先，审核快速不等待</li>
              <li className="flex items-start gap-2"><i className="ri-checkbox-circle-fill mt-0.5 text-accent-500"></i>分类清晰，想看什么一目了然</li>
              <li className="flex items-start gap-2"><i className="ri-checkbox-circle-fill mt-0.5 text-accent-500"></i>发言自由，个人信息严格保护</li>
            </ul>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
              {testimonials.map((t) => (
                <figure key={t.name} className="flex flex-col rounded-xl border border-background-200 bg-background-100 p-5">
                  <i className="ri-double-quotes-l text-3xl text-secondary-300"></i>
                  <blockquote className="mt-2 text-sm leading-relaxed text-foreground-800">{t.text}</blockquote>
                  <figcaption className="mt-4 flex items-center gap-2">
                    <img src={t.avatar} alt={`${t.name}的头像`} className="h-9 w-9 rounded-full object-cover" />
                    <span className="text-xs font-semibold text-foreground-900">{t.name}</span>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}